import { Mode } from '../models/commonEnums';
import { RegisterUserPayload } from '../models/commonModels';
import { CommonActionRequestType, RequestType } from '../reducers/requestReducer';
import { RequestActionType } from './requestActions';

export enum LoginAndRegisterActionType {
    LoginInit = 'LOGIN/INIT',
    LogOutInit = 'LOGOUT/INIT',
    LogOutAllUnitsInit = 'LOGOUT_ALL_UNITS/INIT',
    SetUserEmail = 'SET_USER_EMAIL',
    RegisterUserInit = 'REGISTER_USER/INIT',
    VerifyEmailInit = 'VERIFY_EMAIL/INIT',
    ResentConfirmationCodeInit = 'RESEND_CONFIRMATION_CODE/INIT',
    ExchangeSsoTokenInit = 'EXCHANGE_SSO_TOKEN/INIT',
    SetMode = 'SET_MODE',
}

export interface Login extends CommonActionRequestType {
    type: LoginAndRegisterActionType.LoginInit;
    email: string;
    password: string;
}

export const login = (email: string, password: string): Login => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.Login,
    type: LoginAndRegisterActionType.LoginInit,
    email,
    password,
});

export interface Logout extends CommonActionRequestType {
    type: LoginAndRegisterActionType.LogOutInit;
    loginRedirectUrl?: string;
}

export const logOut = (loginRedirectUrl?: string): Logout => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.LogOut,
    type: LoginAndRegisterActionType.LogOutInit,
    loginRedirectUrl,
});

export interface LogoutAllUnits extends CommonActionRequestType {
    type: LoginAndRegisterActionType.LogOutAllUnitsInit;
    email: string;
}

export const logoutAllUnits = (email: string): LogoutAllUnits => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.LogOutAllUnits,
    type: LoginAndRegisterActionType.LogOutAllUnitsInit,
    email,
});

export interface SetUserEmail {
    type: LoginAndRegisterActionType.SetUserEmail;
    email: string;
}

export const setUserEmail = (email: string): SetUserEmail => ({ type: LoginAndRegisterActionType.SetUserEmail, email });

export interface RegisterUser extends CommonActionRequestType {
    type: LoginAndRegisterActionType.RegisterUserInit;
    payload: RegisterUserPayload;
}

export const registerUser = (payload: RegisterUserPayload): RegisterUser => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.RegisterUser,
    type: LoginAndRegisterActionType.RegisterUserInit,
    payload,
});

export interface VerifyEmail extends CommonActionRequestType {
    type: LoginAndRegisterActionType.VerifyEmailInit;
    email: string;
    confirmationCode: string;
}

export const verifyEmail = (email: string, confirmationCode: string): VerifyEmail => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.VerifyEmail,
    type: LoginAndRegisterActionType.VerifyEmailInit,
    email,
    confirmationCode,
});

export interface ResendConfirmationCode extends CommonActionRequestType {
    type: LoginAndRegisterActionType.ResentConfirmationCodeInit;
    email: string;
}

export const resendConfirmationCode = (email: string): ResendConfirmationCode => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.ResentConfirmationCode,
    type: LoginAndRegisterActionType.ResentConfirmationCodeInit,
    email,
});

export interface SetMode {
    type: LoginAndRegisterActionType.SetMode;
    mode: Mode;
}
export const setMode = (mode: Mode): SetMode => ({
    type: LoginAndRegisterActionType.SetMode,
    mode,
});

export interface ExchangeSsoToken extends CommonActionRequestType {
    type: LoginAndRegisterActionType.ExchangeSsoTokenInit;
}

export const exchangeSsoToken = (): ExchangeSsoToken => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.ExchangeSsoToken,
    type: LoginAndRegisterActionType.ExchangeSsoTokenInit,
});

export type LoginAndRegisterActions = Login | Logout | LogoutAllUnits | SetUserEmail | SetMode;
